import "./App.css";
import Routes1 from "./routes";

function App() {
  return (
    <div className="App">
      <Routes1 />{" "}
    </div>
  );
}

export default App;
